import { render, staticRenderFns } from "./BusinessSummary.vue?vue&type=template&id=35bb566e&scoped=true&lang=pug"
import script from "./BusinessSummary.coffee?vue&type=script&lang=coffee&external"
export * from "./BusinessSummary.coffee?vue&type=script&lang=coffee&external"
import style0 from "./BusinessSummary.sass?vue&type=style&index=0&id=35bb566e&prod&lang=sass&scoped=true&external"
import style1 from "./BusinessSummary.vue?vue&type=style&index=1&id=35bb566e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb566e",
  null
  
)

export default component.exports